module.exports = __webpack_public_path__ + "static/osaka-4-079d3f839b28525bdbe163a96f60b924.png";